import React from 'react';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-50">
      <div className="max-w-md w-full mx-4 space-y-8 p-6 md:p-8 bg-white rounded-2xl shadow-xl">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-14 h-14 md:w-16 md:h-16 bg-primary-100 rounded-full flex items-center justify-center">
              <i className="fas fa-exclamation-triangle text-2xl md:text-3xl text-primary-600"></i>
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Password Reset</h2>
          <p className="mt-2 text-sm md:text-base text-gray-600">Public password reset is disabled</p>
        </div>

        {/* Informational notice */}
        <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded-md text-sm text-yellow-800">
          <div className="flex">
            <div className="flex-shrink-0">
              <i className="fas fa-info-circle text-yellow-500 mr-2"></i>
            </div>
            <div className="flex-1 space-y-2">
              <p className="font-semibold">Self‑service password reset is no longer available.</p>
              <p>
                If you have a <strong>Google account</strong> linked to your profile, please{' '}
                <button
                  onClick={() => navigate('/login')}
                  className="font-medium underline hover:text-yellow-700"
                >
                  go to the login page
                </button>{' '}
                and use the <strong>Sign in with Google</strong> option.
              </p>
              <p>
                Otherwise, contact your school administrator to have your password reset internally.
                They will provide you with a new password or assist you further.
              </p>
            </div>
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col space-y-3">
          <button
            onClick={() => navigate('/login')}
            className="w-full py-3 px-4 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          >
            <i className="fas fa-sign-in-alt mr-2"></i>
            Back to Login
          </button>

          <button
            onClick={() => navigate('/')}
            className="w-full py-3 px-4 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            <i className="fas fa-home mr-2"></i>
            Go to Home
          </button>
        </div>

        <div className="text-center pt-4 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            Powered and hosted by{' '}
            <a
              href="https://cbthost.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:text-primary-700 hover:underline font-medium"
            >
              cbthost.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;